import get from 'lodash/get';
import compose from 'lodash/fp/compose';

// eslint-disable-next-line no-underscore-dangle
const _productCode = submission => get(submission, 'baseData.productCode', 'Unknown');
const cp = s => s === 'CommercialProperty';
const ho = s => s === 'Homeowners';

/**
 * Helper function on Submission object.
 * @returns {{productCode: (function(*=): *), isCommercialProperty: (function(*=): *), isHomeOwners: (function(*=): *)}}
 * @constructor
 *
 * @Examples
 * import TWIASubmissionHelper from 'twia-portals-util-js'
 *      TWIASubmissionHelper.productCode(submission)
 *      TWIASubmissionHelper.isHomeOwners(submission)
 */
const TWIASubmissionHelper = () => {
    const productCode = (submission) => _productCode(submission);
    const isHomeOwners = (submission) => compose(ho, _productCode)(submission);
    const isCommercialProperty = (submission) => compose(cp, _productCode)(submission);

    return {
        productCode,
        isHomeOwners,
        isCommercialProperty
    };
};

export default TWIASubmissionHelper();
